module.exports = __webpack_public_path__ + "static/6305-woodrose-51-8f66cedf74e9e875a29ec39f0e67941b.jpg";